(function () {
	'use strict';

	angular.module('app.leanProjects')
		.controller('valueStreamReportCard', valueStreamReportCard);

	valueStreamReportCard.$inject = ['$scope', '$timeout', '$uibModal', '$rootScope', 'tableService', 'leanFilterService', 
		'viewMetricDataService', 'commentsService', 'tableRenderService', '$state', '$experiments', 'storeService'];

	function valueStreamReportCard($scope, $timeout, $uibModal, $rootScope, tableService, leanFilterService, 
			viewMetricDataService, commentsService, tableRenderService, $state,  $experiments, storeService) {
		var vm = this;
		var rendererParams = {};
		var reportSettingsName = 'report-card';
		var unsubscribe;

		// Extra query params to send to backend in data requests
		var extraParams = [{}];
		var pinnedColumns = [];

		// Set navigation properties
		$timeout(function () {
			jQuery('div.panel-heading').removeClass('selected');
			jQuery('h4.panel-title a').removeClass('selected');
			jQuery('li.list-group-item.selected').removeClass('selected');
			jQuery('#viewValueStreamData').addClass('selected');
		}, 0);
		vm.reportName = 'Value Stream';
		vm.showExcel = false;

		$scope.filterService = leanFilterService;

		var reportSettingsId = $state.params.reportId ? $state.params.reportId : undefined;

		vm.baseReportDisplay = vm.reportName;

		function navigateToBaseReport() {
			$state.go('.', {reportId: undefined});
		}

		vm.navigateToBaseReport = navigateToBaseReport;
		vm.showEnterMetricData = true;

		if (reportSettingsId) {
			vm.showInfo = true;
			vm.isSavedReport = true;
			vm.reportName = '';
		} else {
			vm.showSaveReport = true;
			vm.isSavedReport = false;
		}

		$scope.$on('reportConfigReady', function () {
			var reportSettings = storeService.getState().reportSettings;
			
			if (reportSettings.viewType === 'savedLeanProjects') {

				vm.userDescription = reportSettings.userDescription;
				vm.reportName = storeService.getState().reportSettings.reportName;
				unsubscribe = storeService.subscribe(function () {
					var state = storeService.getState();
					if (state.reportSettings.reportName !== vm.reportName) {
						vm.reportName = state.reportSettings.reportName;
					}
					if (state.reportSettings.userDescription !== vm.userDescription) {
						vm.userDescription = state.reportSettings.userDescription;
					}
				});
			}
		});

		var defaultFilters = [{'id': 'factory', 'values': [globalConfig.factory.id], 'isMandatory': true}];
		
		var columns = [{
			'id': 'valueStreamName',
			'display': 'Value Stream',
			'renderer': tableRenderService.valueStreamReportCardRenderer,
			'width': 200,
			'class': 'valueStreamCell'
		},
		{
			'id': 'personName',
			'display': 'Responsible',
			'width': 150
		}];

		var meta = {
			reportSettingsName: reportSettingsName,
			reportSettingsId: reportSettingsId,
			reportUrl: '{0}/ValueStreamsReport',
			noPaging: true,
			columns: columns,
			pinnedColumns: pinnedColumns,
			defaultFilters: defaultFilters,
			defaultSort: 'valueStreamName',
			defaultSortDirection: 'asc',
			extraParams: extraParams,
			rendererParams: rendererParams,
			pageSize: 50,
			setColumnDefaults: true,
			hideSearch: true,
			reportSettingsScope: 'customer'
		};

		vm.getData = getData;
		vm.getMeta = getMeta;
		vm.openReportCard = openReportCard;

		function getMeta() {
			return meta;
		}

		function getData(params, extraParams) {
			return tableService.getData(params, extraParams).then(function (response) {
				// If any data manipulation is needed, do it here
				return response;
			});
		}

		function openReportCard(valueStreamNdx, valueStreamName, userNdx) {
			$rootScope.vsNdx = valueStreamNdx;

			var modalInstance = $uibModal.open({
				animation: true,
				templateUrl: '/application/f/lean-projects/metric/report-card.html',
				windowTemplateUrl: '/application/f/lean-projects/metric/report-card-template.html',
				controller: 'reportCardReportCtrl',
				resolve: {
					vsNdx: function() {
						return valueStreamNdx;
					}
				}
			});
		};
        
		function init() {
			leanFilterService.clearFilters();
			$scope.filterService.useFactoryFilter = true;
			var siteFilter = leanFilterService.filterDefinitions['Factory'];
			siteFilter.type = 'singleSelect';
			siteFilter.removable = false;
			$scope.filterService.setMasterFilterList([]);
			$scope.filterService.setMasterRangeFilterList([]);
			$scope.filterService.setMasterSingleSelectFilterList([siteFilter]);
		}

		init();
	}
})();
